const KEY = "ambasada.seenPosts";
const CAP = 200;

export const readSeenPosts = () => {
    try {
        const raw = window.localStorage.getItem(KEY);
        if (!raw) return new Set();
        const arr = JSON.parse(raw);
        return new Set(Array.isArray(arr) ? arr : []);
    } catch {
        return new Set();
    }
};

export const markPostsSeen = (ids) => {
    if (!ids || ids.length === 0) return;
    try {
        const current = readSeenPosts();
        ids.forEach((id) => current.add(id));
        const arr = [...current].slice(-CAP);
        window.localStorage.setItem(KEY, JSON.stringify(arr));
    } catch {
        // localStorage unavailable / quota — feature degrades to "no dimming."
    }
};
